import React from 'react';
import { MenuItem } from 'src/components/FormatsMenu/components/Item';

import { Search } from '@sravni/react-icons';
import { SearchBlock } from '@sravni/react-ugc/lib/Search';
import { useBoolean, useIsMobile } from '@sravni/react-utils';

import { useIsSearchPage } from '../../../../hooks/pageType';
import { getPlaceholder, searchAndNavigate } from '../../helpers';

export const MenuSearch = () => {
  const [isFocused, setFocused] = useBoolean(false);
  const isSearchPage = useIsSearchPage();
  const isMobile = useIsMobile();

  const item = {
    name: 'Поиск',
    icon: <Search />,
    link: null,
    isActive: isSearchPage,
    isVisible: true,
  };

  const placeholder = getPlaceholder(isMobile);

  return isSearchPage || !isFocused ? (
    <MenuItem item={item} onClick={setFocused.on} />
  ) : (
    <SearchBlock onBlur={setFocused.off} onSearch={searchAndNavigate} isTopBlock={false} placeholder={placeholder} />
  );
};

MenuSearch.displayName = 'MenuSearch';
